export interface ExpenseReconciliationPageInput {
  limit?: number;
  nextToken?: string;
  fechaDesde?: string;
  fechaHasta?: string;
  banco?: string;
  estado?: string;
}

export interface ExpenseReconciliationRow {
  transactionId: string;
  numeroOperacion?: string | null;
  banco?: string | null;
  fecha?: string | null;
  monto?: number | null;
  estado?: string | null;
  transaccionVinculadaId?: string | null;
  variante?: string | null;
  pagoId?: string | null;
  comision?: number | null;
  proveedorNombre?: string | null;
  tipoOrden?: string | null;
  fechaPago?: string | null;
  estadoPago?: string | null;
  vinculoEncontrado: boolean;
}

export interface ExpenseReconciliationPage {
  items: ExpenseReconciliationRow[];
  nextToken: string | null;
  hasMore: boolean;
}

export interface ExpenseReconciliationPageResponse {
  getConciliacionEgresosPage: ExpenseReconciliationPage;
}

export interface ExpenseReconciliationProgress {
  items: ExpenseReconciliationRow[];
  loadedPages: number;
  hasMore: boolean;
}
